import { Link } from "react-router-dom";
import CycleGauge from "./CycleGauge";
import CycleStats from "./CycleStats";

export function SevenYearCycleWidget() {
  return (
    <div className="rounded-xl border border-border/60 bg-card/50 backdrop-blur p-5 md:p-6">
      <p className="font-plex text-[11px] uppercase mb-1" style={{ letterSpacing: "2.5px", color: "var(--cycle-teal-hex)" }}>
        The Seven-Year Cycle
      </p>
      <h2 className="text-xl font-bold text-foreground mb-4">Where are we in the cycle?</h2>

      <CycleGauge size={320} className="md:max-w-[320px] max-w-[280px]" />

      <CycleStats className="mt-5" />

      <div className="mt-4">
        <Link
          to="/cycle"
          className="font-plex text-xs hover:underline"
          style={{ color: "var(--cycle-teal-hex)" }}
        >
          Read the full cycle analysis →
        </Link>
      </div>
    </div>
  );
}

export default SevenYearCycleWidget;
